import React, { useEffect, useState } from 'react'
import Modal from '../../../common/modal'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { LrDetailsColumns } from './constant'
import { connect } from 'react-redux'
import { GetLRDetailsForPopUpV2Data, getLuggageModificationReportData } from '../../../../store/reports/reports_action'
import moment from 'moment'

const LuggageModel = (props) => {
  const {
    data: { common, reports },
    lRInput,
    fromDate,
    toDate,
    selBranch,
    updateModal,
    lrDetailsPopupData,
    GetLRDetailsForPopUpV2Data,
    getLuggageModificationReportData,
    setTableData,
    onSelectLR, isFromUrl
  } = props
  const { loginData, showModal, modalType } = common
  const { lagguageModificationReportData } = reports
  const [lrModelCheck, setLrModelCheck] = useState(false)
  const [lrTableData, setLRTableData] = useState([])
  useEffect(() => {
    const data = lrDetailsPopupData?.map((val) => ({ ...val }))
    setLRTableData(data || [])
  }, [lrDetailsPopupData])
  useEffect(() => {
    const data2 = lagguageModificationReportData?.map((val) => ({ ...val }))
    setTableData(data2 || [])
  }, [lagguageModificationReportData])
  const handleGo = () => {
    if (lrModelCheck) {
      const obj2 = {
        strLRNO: lRInput,
        intCompanyID: loginData.intCompanyID,
        intBranchID: loginData.intBranchID,
        intUserID: loginData.intUserID,
        intBranchCityID: loginData.intBranchCityID,
        intisCurrentYear: 0,
      }
      GetLRDetailsForPopUpV2Data(obj2)
    }
  }
  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <>
        <TableRow>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left', cursor: 'pointer', color: '#1976d2' }}
              onClick={() => onSelectLR(item)}
            >
              {item.LRNo}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.FormattedLRNo}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.ManualLRNo}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.BookingDateTime}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.PaymentTypeDet}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.Sender}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'left' }}
            >
              {item.RecName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.FromCity}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.ToCity}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }

  const CardView = ({ item, fontVal }) => (
    <Box
      onClick={() => onSelectLR(item)}
      sx={{
        border: '2px solid #0086ff',
        borderRadius: '6px',
        marginBottom: '12px',
        cursor: 'pointer',
        overflow: 'hidden',
        '&:hover': { opacity: 0.85 }
      }}
    >
      <Box sx={{ backgroundColor: '#0086ff', display: 'flex', justifyContent: 'space-between', padding: '6px 6px' }}>
        <span style={{ color: '#fff', fontWeight: '600', fontSize: fontVal }}>WayBill No (LR No):</span>
        <span style={{ color: '#fff', fontWeight: '600', fontSize: fontVal }}>{item.LRNo || item.FormattedLRNo}</span>
      </Box>
      {[
        ['Payment Type:', item.PaymentTypeDet],
        ['Source City:', item.FromCity?.split(',')[0]],
        ['Destination City:', item.ToCity?.split(',')[0]],
        ['Sender Name:', item.Sender],
        ['Receiver Name:', item.RecName],
      ].map(([label, value]) => (
        <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', padding: '4px 10px', borderBottom: '1px solid #e0e0e0' }}>
          <span style={{ fontWeight: '600', fontSize: fontVal }}>{label}</span>
          <span style={{ fontSize: fontVal }}>{value}</span>
        </Box>
      ))}
    </Box>
  )
  return (
    <Modal headTxt={`LR Details`} width={'70%'} updateModal={updateModal}>
      {!isFromUrl && (
        <Box style={{ display: 'flex', justifyContent: 'flex-start', margin: '15px' }}>
          <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '40px' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id="LRSearch"
                  checked={lrModelCheck}
                  onChange={() => {
                    setLrModelCheck(!lrModelCheck)
                  }}
                />
              }
              label={'Show All Data'}
              labelPlacement="end"
            />
          </Box>
          <Item sx={sx.itemsx}>
            <Button variant="contained" className="go click-button" onClick={handleGo}>
              GO
            </Button>
          </Item>
        </Box>
      )}
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 430, paddingTop: '10px', marginBottom: '20px' }}>
        {isFromUrl ? (
          // Card view for URL mode
          lrTableData?.length < 1 ? (
            <div style={{ color: 'red', textAlign: 'center', marginTop: '20px', fontSize: '12px' }}>
              No results found. Please refine your search parameters and search again.
            </div>
          ) : (
            lrTableData.map((item, index) => (
              <CardView key={index} item={item} fontVal={'13px'} />
            ))
          )
        ) : (
          <TableContainer className="scroll" style={{ border: '1px solid #aeaeae' }} component={Paper}>
            <Table className="table1 table-Report" size="small" aria-label="a dense table">
              <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                <TableRow>
                  {LrDetailsColumns?.map((i, index) => (
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#bfe1ff',
                        color: '#444444',
                        fontSize: '12px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '500',
                        textAlign: `${i.align}`,
                      }}
                      colSpan={1}
                    >
                      {i.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {lrTableData?.length < 1 ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={13}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '12px',
                            lineheight: '16px',
                            letterspacing: '0.24px',
                          }}
                        >
                          <span>No results found. Please refine your search parameters and search again.</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : lrTableData?.length >= 1 ? (
                <TableBody
                  className="filter-data-row"
                  style={{
                    textAlign: 'center',
                    fontSize: '12px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  {lrTableData?.map((item, index) => (
                    <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
          </TableContainer>
        )}
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { GetLRDetailsForPopUpV2Data, getLuggageModificationReportData }
export default connect(mapStateToProps, mapDispatchToProps)(LuggageModel)
